import { ChevronLeft, Bell } from 'lucide-react';
import { Link } from 'react-router';
import { PacienteBottomNav } from '@/app/components/paciente/PacienteBottomNav';

export function NotificacionesPaciente() {
  return (
    <div className="min-h-screen bg-background transition-colors duration-200">
      <div className="w-full max-w-[480px] mx-auto p-6 pb-24 space-y-6">
        <div className="flex items-center gap-4">
          <Link to="/perfil" className="transition-all duration-200 ease-out hover:opacity-70">
            <ChevronLeft className="w-6 h-6" strokeWidth={1.5} />
          </Link>
          <h1 className="text-2xl">Notificaciones</h1>
        </div>

        <div className="space-y-4">
          <div className="bg-card rounded-3xl p-5 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Bell className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <span className="font-medium">Recordatorios de sesiones</span>
              </div>
              <button className="w-12 h-7 bg-primary rounded-full relative transition-all duration-200 ease-out">
                <div className="absolute right-1 top-1 w-5 h-5 bg-white rounded-full"></div>
              </button>
            </div>
            <p className="text-sm text-muted-foreground">
              Recibí una notificación 30 minutos antes de cada sesión programada
            </p>
          </div>

          <div className="bg-card rounded-3xl p-5 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Bell className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <span className="font-medium">Mensajes del kinesiólogo</span>
              </div>
              <button className="w-12 h-7 bg-primary rounded-full relative transition-all duration-200 ease-out">
                <div className="absolute right-1 top-1 w-5 h-5 bg-white rounded-full"></div>
              </button>
            </div>
            <p className="text-sm text-muted-foreground">
              Notificaciones cuando tu kinesiólogo te envíe un mensaje
            </p>
          </div>

          <div className="bg-card rounded-3xl p-5 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Bell className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <span className="font-medium">Actualizaciones de progreso</span>
              </div>
              <button className="w-12 h-7 bg-muted rounded-full relative transition-all duration-200 ease-out">
                <div className="absolute left-1 top-1 w-5 h-5 bg-white rounded-full"></div>
              </button>
            </div>
            <p className="text-sm text-muted-foreground">
              Resumen semanal de tu adherencia y mejoras
            </p>
          </div>

          <div className="bg-card rounded-3xl p-5 border border-border shadow-[0_1px_2px_rgba(15,23,32,0.04),0_1px_3px_rgba(15,23,32,0.06)]">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Bell className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <span className="font-medium">Logros y rachas</span>
              </div>
              <button className="w-12 h-7 bg-primary rounded-full relative transition-all duration-200 ease-out">
                <div className="absolute right-1 top-1 w-5 h-5 bg-white rounded-full"></div>
              </button>
            </div>
            <p className="text-sm text-muted-foreground">
              Celebrá tus logros cuando alcances nuevas metas
            </p>
          </div>
        </div>
      </div>

      <PacienteBottomNav />
    </div>
  );
}
